import type { ParsedCoords } from './parseCoordinates'
import { parseCoordinates } from './parseCoordinates'

export type CoordinateInputSuggestion = {
  id: string
  primary: string
  secondary?: string
  applyFull?: string
}

function collapseWs(s: string): string {
  return s.trim().replace(/\s+/g, '')
}

export function formatDecimalDegreesCompact(coords: ParsedCoords): string {
  const trimNum = (n: number) => {
    let s = n.toFixed(6)
    s = s.replace(/(?:\.0+|(?<=\.[0-9]*?)0+)$/, '')
    if (s.endsWith('.')) s = s.slice(0, -1)
    return s
  }
  return `${trimNum(coords.lat)}, ${trimNum(coords.lng)}`
}

export function getCoordinateInputSuggestions(
  raw: string,
): CoordinateInputSuggestion[] {
  const s = raw.trim()
  const out: CoordinateInputSuggestion[] = []
  if (!s) return out

  const parsed = parseCoordinates(s)
  if (parsed) {
    const compact = formatDecimalDegreesCompact(parsed)
    if (collapseWs(s) !== collapseWs(compact)) {
      out.push({
        id: 'coord-dd-compact',
        primary: compact,
        secondary: 'Décimal WGS84 — toucher pour utiliser',
        applyFull: compact,
      })
    }
    return out
  }

  if (/°/.test(s) || /[′'″"]/.test(s) || /[NSEW]/i.test(s)) {
    out.push({
      id: 'coord-dms-example',
      primary: '45°48′30″N 6°52′12″E',
      secondary: 'Exemple DMS · copier puis adapter',
      applyFull: '45°48′30″N 6°52′12″E',
    })
    return out
  }

  const incompleteComma =
    /^(-?\d+(?:\.\d*)?)\s*[,;]\s*(-?\d+(?:\.\d*)?)?$/.exec(s)
  if (incompleteComma && incompleteComma[2] === undefined) {
    out.push({
      id: 'coord-dd-needs-lng',
      primary: 'Latitude saisie — ajoutez la longitude',
      secondary: 'Après la virgule, ex. 6.870000',
    })
    return out
  }

  const dmmPartial =
    /^(-?\d{1,3})\s+([\d.]+)\s*[,;]\s*(-?\d{1,3})\s+([\d.]*)$/.exec(s)
  if (dmmPartial && (dmmPartial[4] === '' || dmmPartial[4] === undefined)) {
    out.push({
      id: 'coord-dmm-needs-min',
      primary: 'DMM incomplet',
      secondary: 'Minutes décimales pour les deux axes, ex. 45 48.5, 6 52.2',
    })
  }

  return out
}
